export default {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
};
